import { FormGroup } from "@angular/forms";
import { PaymentVerification, PaymentVerificationPayload } from "../models/payment-verification";
import { formatDate } from "./date-validators";

export function mapToVerifyPayment(paymentVerification: PaymentVerification, action: string, verificationForm: FormGroup): PaymentVerificationPayload {
    let form = verificationForm.getRawValue();
    return {
        purchaseOrderId: paymentVerification.id,
        paymentReference: paymentVerification.paymentReference,
        paymentDate: formatDate(form['paymentDate']),
        comments: form['notes'],
        action: action
    }
}